import * as core from '../../../../../../../core'

import { query } from './trends-stacked.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.trends.widgets.stacked-bar-chart',
    description:
      'Stacked bar chart showing trends in expenses broken down by department and PI over the last five years.',
    name: 'RP Trends - Stacked Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
